import React from 'react';
import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
  isCurrentPage?: boolean;
}

const Breadcrumb: React.FC = () => {
  const location = useLocation();
  
  const getBreadcrumbItems = (): BreadcrumbItem[] => {
    const pathSegments = location.pathname.split('/').filter(segment => segment !== '');
    
    if (pathSegments.length === 0) {
      return [{ label: 'Christopher Samuels', isCurrentPage: true }];
    }
    
    const items: BreadcrumbItem[] = [];
    
    // Handle different page types
    if (pathSegments[0] === 'tuney') {
      // Tuney page - show parent and current
      items.push({ label: 'Home', path: '/' });
      items.push({ label: 'Tuney', isCurrentPage: true });
    } else if (pathSegments[0] === 'bace') {
      // Bace page - show parent and current
      items.push({ label: 'Home', path: '/' });
      items.push({ label: 'Bace', isCurrentPage: true });
    } else if (pathSegments[0] === 'cbyon') {
      // CBYON page - show parent and current
      items.push({ label: 'Home', path: '/' });
      items.push({ label: 'CBYON', isCurrentPage: true });
    } else if (pathSegments[0] === 'brewerydb') {
      // BreweryDB page - show parent and current
      items.push({ label: 'Home', path: '/' });
      items.push({ label: 'BreweryDB', isCurrentPage: true });
    } else if (pathSegments[0] === 'brewlogix') {
      // BrewLogix page - show parent and current
      items.push({ label: 'Home', path: '/' });
      items.push({ label: 'BrewLogix', isCurrentPage: true });
    } else if (pathSegments[0] === 't-mobile-5gin') {
      // T-Mobile 5Gin page - show parent and current
      items.push({ label: 'Home', path: '/' });
      items.push({ label: 'T-Mobile 5Gin', isCurrentPage: true });
    } else if (pathSegments[0] === 'about') {
      // About page - show only current
      items.push({ label: 'About', isCurrentPage: true });
    }
    
    return items;
  };
  
  const breadcrumbItems = getBreadcrumbItems();
  
  return (
    <nav className="ml-2">
      <ol className="flex flex-wrap items-center gap-1.5 text-sm break-words sm:gap-2.5 font-mono-recursive">
        {breadcrumbItems.map((item, index) => (
          <React.Fragment key={index}>
            {index > 0 && (
              <li role="presentation" aria-hidden="true" className="[&>svg]:size-3.5">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                  fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                  strokeLinejoin="round" className="lucide lucide-chevron-right">
                  <path d="m9 18 6-6-6-6"></path>
                </svg>
              </li>
            )}
            <li className="inline-flex items-center gap-1.5">
              {item.isCurrentPage ? (
                <span 
                  role="link" 
                  aria-disabled="true" 
                  aria-current="page" 
                  className="dark:text-white font-normal"
                >
                  {item.label}
                </span>
              ) : (
                <Link 
                  to={item.path || '/'}
                  className="text-zinc-500 dark:text-zinc-400 hover:text-zinc-900 dark:hover:text-white transition-colors"
                >
                  {item.label}
                </Link>
              )}
            </li>
          </React.Fragment>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
